import React, { forwardRef, useContext, useEffect, useRef, useState } from "react"
import { useForm, Controller } from "react-hook-form"
import { useHistory, useLocation } from "react-router-dom"
import { useSnackbar } from "../../utils/notificacoes"
import { Autocomplete as GoogleAutocomplete } from "@react-google-maps/api"

import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Checkbox from "@material-ui/core/Checkbox"
import Chip from "@material-ui/core/Chip"
import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Link from "@material-ui/core/Link"
import MenuItem from "@material-ui/core/MenuItem"
import Paper from "@material-ui/core/Paper"
import Step from "@material-ui/core/Step"
import StepButton from "@material-ui/core/StepButton"
import Stepper from "@material-ui/core/Stepper"
import MuiTextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import { makeStyles } from "@material-ui/core/styles"

import QRCode from "qrcode"

import api from "../../services/api"
import {
    onboardingRestaurante,
    salvarRascunhoOnboarding,
    obterRascunhoOnboarding,
    obterStatusOnboarding,
} from "../../services/integracao"
import { RegistrarLogErro } from "../../services/clientefiel"
import ServicosContext from "../../contexts/servicosContext"
import useAppStore from "../../stores/AppStore"
import { MascaraCpfCnpj, MascaraTelefone, CATEGORIAS } from "../CadastroEstabelecimento/masks"
import { PLANOS_ONBOARDING } from "./planos"

// Wrapper que (1) encaminha o ref do register() do react-hook-form para o inputRef
// do MuiTextField e (2) força o label a ficar encolhido — evita o overlap do MUI v4
// quando o react-hook-form preenche campos programaticamente (endereço via Google).
const TextField = forwardRef((props, ref) => (
    <MuiTextField
        {...props}
        inputRef={ref}
        InputLabelProps={{ shrink: true, ...(props.InputLabelProps || {}) }}
    />
))

const PASSOS = ["Loja", "Endereço", "Responsável", "Identidade", "Plano", "Pagamento"]
// Último passo de dados (dispara o "Finalizar cadastro").
const PASSO_PLANO = 4
// Passo pós-cadastro: mostra o QR Code da 1ª fatura (só é alcançado após o finalize).
const PASSO_PAGAMENTO = 5

const COR_PADRAO = "#E74A3B"
const COR_SECUNDARIA_PADRAO = "#EFC500"
const MAX_LOGO_BYTES = 2 * 1024 * 1024

const URL_TERMOS =
    "https://docs.google.com/document/d/1GGA-eaaErcQDYGtqnBl58KS152xdXymfR9KOXFJgWYQ/edit?tab=t.0"

const useStyles = makeStyles(theme => ({
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e8edf3 100%)",
        padding: theme.spacing(4, 2),
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
    },
    card: {
        width: "100%",
        maxWidth: 760,
        borderRadius: 20,
        boxShadow: "0 10px 40px rgba(0,0,0,0.10)",
        backgroundColor: "#fff",
        overflow: "hidden",
    },
    header: {
        padding: theme.spacing(3, 4, 1),
    },
    titulo: {
        fontWeight: 800,
        color: "#1f2a44",
    },
    subtitulo: {
        color: "#6b7280",
        marginTop: 4,
    },
    stepper: {
        backgroundColor: "transparent",
        padding: theme.spacing(1, 2, 0),
    },
    body: {
        padding: theme.spacing(2, 4, 4),
    },
    campo: {
        marginTop: theme.spacing(2),
    },
    acoes: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: theme.spacing(4),
    },
    btnPrimario: {
        borderRadius: 25,
        padding: theme.spacing(1, 4),
        fontWeight: 700,
        boxShadow: "0 4px 15px rgba(var(--cor-botao-salvar-rgb),0.3)",
        backgroundColor: "var(--cor-botao-salvar)",
        color: "#fff",
        "&:hover": { backgroundColor: "var(--cor-botao-salvar-hover)" },
    },
    planoCard: {
        borderRadius: 16,
        border: "2px solid #e5e7eb",
        cursor: "pointer",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all .15s ease",
        position: "relative",
        "&:hover": { borderColor: "#a5d6a7" },
    },
    planoCardContent: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    planoFeatures: {
        marginTop: 8,
    },
    planoCardSelecionado: {
        borderColor: "#4caf50",
        boxShadow: "0 6px 22px rgba(var(--cor-botao-salvar-rgb),0.25)",
    },
    planoPreco: {
        fontWeight: 800,
        color: "#1f2a44",
    },
    chipRecomendado: {
        position: "absolute",
        top: -12,
        right: 12,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "#fff",
        fontWeight: 700,
    },
    feature: {
        display: "flex",
        alignItems: "flex-start",
        gap: 6,
        color: "#374151",
        fontSize: 12,
        lineHeight: 1.3,
        marginTop: 5,
    },
    featureIcon: {
        fontSize: 15,
        color: "#4caf50",
        marginTop: 1,
        flexShrink: 0,
    },
    sucesso: {
        textAlign: "center",
        padding: theme.spacing(5, 4),
    },
    sucessoIcon: {
        fontSize: 64,
        color: "#4caf50",
    },
    faturaBox: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(3),
        borderRadius: 16,
        backgroundColor: "#f8fafc",
        border: "1px solid #e5e7eb",
        textAlign: "left",
    },
}))

const VALORES_PADRAO = {
    nome: "",
    cnpj: "",
    categoria: "",
    emailLoja: "",
    whatsappLoja: "",
    endereco: "",
    numero: "",
    bairro: "",
    cep: "",
    nomeCidade: "",
    ufCidade: "",
    latitude: "",
    longitude: "",
    nomeResponsavel: "",
    emailCliente: "",
    whatsappCliente: "",
    corPrimaria: COR_PADRAO,
    corSecundaria: COR_SECUNDARIA_PADRAO,
    planoAssinatura: "PLANO2",
}

// Extrai os campos de endereço de um place do Google Places.
function parsePlace(place) {
    const get = (type, short = false) => {
        const c = (place.address_components || []).find(x => x.types.includes(type))
        return c ? (short ? c.short_name : c.long_name) : ""
    }
    return {
        endereco: get("route"),
        numero: get("street_number"),
        bairro: get("sublocality") || get("sublocality_level_1") || get("neighborhood"),
        cidade: get("administrative_area_level_2") || get("locality"),
        uf: get("administrative_area_level_1", true),
        cep: get("postal_code"),
        lat: place.geometry?.location?.lat?.(),
        lng: place.geometry?.location?.lng?.(),
    }
}

export default function OnboardingRestaurante() {
    const classes = useStyles()
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar()
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)
    const servicos = useContext(ServicosContext)

    const location = useLocation()
    const { register, handleSubmit, control, trigger, setValue, getValues, reset, formState: { errors } } =
        useForm({ defaultValues: VALORES_PADRAO, mode: "onBlur" })

    const [activeStep, setActiveStep] = useState(0)
    const [enviando, setEnviando] = useState(false)
    const [resultado, setResultado] = useState(null)
    const [mesmoEmail, setMesmoEmail] = useState(true)
    const [mesmoWhatsapp, setMesmoWhatsapp] = useState(true)
    const [aceitouTermos, setAceitouTermos] = useState(false)
    const [rascunhoToken, setRascunhoToken] = useState(null)
    const [veioDeLink, setVeioDeLink] = useState(false)
    const [salvandoRascunho, setSalvandoRascunho] = useState(false)
    const [linkDialog, setLinkDialog] = useState(null) // string do link gerado
    const [logoBase64, setLogoBase64] = useState("") // base64 sem prefixo data:
    const [logoPreview, setLogoPreview] = useState("") // data URL para preview
    const [qrPagamento, setQrPagamento] = useState("") // data URL do QR da fatura Iugu
    const [somenteLeitura, setSomenteLeitura] = useState(false) // revisão pós-cadastro (sem edição)
    const autocompleteRef = useRef(null)

    const handleLogo = file => {
        if (!file) return
        if (file.size > MAX_LOGO_BYTES) {
            enqueueSnackbar("Imagem maior que 2MB.", { variant: "warning" })
            return
        }
        if (!file.type.startsWith("image/")) {
            enqueueSnackbar("Envie um arquivo de imagem.", { variant: "warning" })
            return
        }
        const reader = new FileReader()
        reader.onload = () => {
            const dataUrl = String(reader.result || "")
            setLogoPreview(dataUrl)
            setLogoBase64(dataUrl.includes(",") ? dataUrl.split(",")[1] : dataUrl) // sem prefixo
        }
        reader.readAsDataURL(file)
    }

    // Carrega o link ?r=<token>: sempre preenche o wizard com o rascunho (para conferência);
    // se o cadastro já foi finalizado, abre direto no Pagamento (com o QR) em modo somente-leitura,
    // permitindo voltar e revisar os campos já cadastrados sem poder editá-los.
    useEffect(() => {
        const token = new URLSearchParams(location.search).get("r")
        if (!token) return
        let cancelado = false
        ;(async () => {
            const resp = await obterRascunhoOnboarding(token)
            if (cancelado) return
            const temRascunho = !resp.retornoErro
            if (temRascunho) {
                const d = resp.data || {}
                reset({
                    ...VALORES_PADRAO,
                    ...d,
                    corPrimaria: d.corPrimaria || COR_PADRAO,
                    corSecundaria: d.corSecundaria || COR_SECUNDARIA_PADRAO,
                    planoAssinatura: d.planoAssinatura || "PLANO2",
                })
                if (d.logoBase64) {
                    setLogoBase64(d.logoBase64)
                    setLogoPreview(`data:image/*;base64,${d.logoBase64}`)
                }
                setRascunhoToken(d.rascunhoToken || token)
                setVeioDeLink(true)
                // Se o rascunho já trouxe e-mail/WhatsApp do cliente distintos, desmarca "usar o mesmo".
                if (d.emailCliente && d.emailCliente !== d.emailLoja) setMesmoEmail(false)
                if (d.whatsappCliente && d.whatsappCliente !== d.whatsappLoja) setMesmoWhatsapp(false)
            } else {
                setRascunhoToken(token)
            }

            const st = await obterStatusOnboarding(token)
            if (cancelado) return
            if (!st.retornoErro && st.data && st.data.concluido) {
                setVeioDeLink(true)
                setResultado(st.data)
                setSomenteLeitura(true)
                setActiveStep(PASSO_PAGAMENTO)
                return
            }

            if (!temRascunho) {
                enqueueSnackbar(resp.mensagem, { variant: "warning" })
            }
        })()
        return () => {
            cancelado = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search])

    const googleDisponivel =
        typeof window !== "undefined" && window.google && window.google.maps && window.google.maps.places

    // "Salvar e enviar ao cliente" é ação do vendedor logado da Cliente Fiel; some para
    // quem está se cadastrando sozinho (sem sessão).
    const estaLogado = !!localStorage.getItem("chaveSistema")

    const camposPorPasso = [
        ["nome", "cnpj", "categoria", "emailLoja", "whatsappLoja"],
        ["endereco", "numero"],
        ["nomeResponsavel", ...(mesmoEmail ? [] : ["emailCliente"]), ...(mesmoWhatsapp ? [] : ["whatsappCliente"])],
        [], // Identidade — logo/cores são opcionais
        ["planoAssinatura"],
    ]

    const onPlaceChanged = () => {
        try {
            const place = autocompleteRef.current && autocompleteRef.current.getPlace()
            if (!place) return
            const d = parsePlace(place)
            if (d.endereco) setValue("endereco", d.endereco, { shouldValidate: true })
            if (d.numero) setValue("numero", d.numero, { shouldValidate: true })
            if (d.bairro) setValue("bairro", d.bairro)
            if (d.cidade) setValue("nomeCidade", d.cidade)
            if (d.uf) setValue("ufCidade", d.uf)
            if (d.cep) setValue("cep", d.cep)
            if (typeof d.lat === "number") setValue("latitude", String(d.lat))
            if (typeof d.lng === "number") setValue("longitude", String(d.lng))
        } catch (e) {
            RegistrarLogErro(e, "OnboardingRestaurante.onPlaceChanged")
        }
    }

    const avancar = async () => {
        // Em modo revisão (somente-leitura) navega sem validar.
        if (!somenteLeitura) {
            const ok = await trigger(camposPorPasso[activeStep])
            if (!ok) return
        }
        setActiveStep(s => s + 1)
    }

    const voltar = () => setActiveStep(s => Math.max(0, s - 1))

    // Navegação direta pelos números do stepper. Em modo revisão (cadastro concluído) é livre;
    // no preenchimento, voltar é livre e avançar valida o passo atual. O passo Pagamento só é
    // acessível depois do cadastro concluído (quando há resultado).
    const irParaPasso = async index => {
        if (index === activeStep) return
        if (index === PASSO_PAGAMENTO && !resultado) return
        if (somenteLeitura || index <= activeStep) {
            setActiveStep(index)
            return
        }
        const ok = await trigger(camposPorPasso[activeStep])
        if (!ok) return
        setActiveStep(index)
    }

    // Vendedor salva o cadastro parcial e recebe um link para enviar ao dono do restaurante.
    const salvarRascunho = async () => {
        setSalvandoRascunho(true)
        const dados = getValues()
        const body = {
            ...dados,
            emailCliente: mesmoEmail ? dados.emailLoja : dados.emailCliente,
            whatsappCliente: mesmoWhatsapp ? dados.whatsappLoja : dados.whatsappCliente,
            logoBase64: logoBase64 || undefined,
            rascunhoToken: rascunhoToken || undefined,
        }
        const resp = await salvarRascunhoOnboarding(body)
        setSalvandoRascunho(false)
        if (resp.retornoErro) {
            enqueueSnackbar(resp.mensagem || "Não foi possível salvar o rascunho.", { variant: "error" })
            return
        }
        setRascunhoToken(resp.token)
        const link = `${window.location.origin}/comece-agora?r=${resp.token}`
        setLinkDialog(link)
    }

    const copiarLink = async () => {
        try {
            await navigator.clipboard.writeText(linkDialog)
            enqueueSnackbar("Link copiado!", { variant: "success" })
        } catch (_) {
            enqueueSnackbar("Copie o link manualmente.", { variant: "info" })
        }
    }

    const copiarLinkPagamento = async () => {
        try {
            await navigator.clipboard.writeText(resultado?.urlIugu || "")
            enqueueSnackbar("Link de pagamento copiado!", { variant: "success" })
        } catch (_) {
            enqueueSnackbar("Copie o link manualmente.", { variant: "info" })
        }
    }

    const copiarPix = async () => {
        try {
            await navigator.clipboard.writeText(resultado?.pixCopiaECola || "")
            enqueueSnackbar("Código PIX copiado!", { variant: "success" })
        } catch (_) {
            enqueueSnackbar("Copie o código manualmente.", { variant: "info" })
        }
    }

    // Gera o QR Code da 1ª fatura. Preferimos o PIX copia-e-cola (escaneável direto no
    // app do banco); se a fatura não trouxe PIX, cai para o link de pagamento da Iugu.
    useEffect(() => {
        const conteudoQr = resultado?.pixCopiaECola || resultado?.urlIugu
        if (!conteudoQr) {
            setQrPagamento("")
            return
        }
        QRCode.toDataURL(conteudoQr, { width: 220, margin: 1 }, (err, url) => {
            if (err) {
                RegistrarLogErro(err, "OnboardingRestaurante.gerarQrPagamento")
                setQrPagamento("")
                return
            }
            setQrPagamento(url)
        })
    }, [resultado])

    // Reconsulta o status da fatura pelo token do link (usado no botão "Atualizar" e no poll).
    const atualizarStatusPagamento = async ({ silencioso } = {}) => {
        if (!rascunhoToken) return
        const st = await obterStatusOnboarding(rascunhoToken)
        if (st.retornoErro || !st.data || !st.data.concluido) return
        setResultado(st.data)
        if (!silencioso) {
            enqueueSnackbar(
                st.data.faturaPaga ? "Pagamento confirmado!" : "Ainda não identificamos o pagamento.",
                { variant: st.data.faturaPaga ? "success" : "info" }
            )
        }
    }

    // Enquanto a fatura não é paga, verifica o status a cada 20s para atualizar a tela sozinha.
    useEffect(() => {
        if (activeStep !== PASSO_PAGAMENTO || !resultado || !rascunhoToken || resultado.faturaPaga) {
            return
        }
        const id = setInterval(() => {
            atualizarStatusPagamento({ silencioso: true })
        }, 20000)
        return () => clearInterval(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeStep, resultado, rascunhoToken])

    const finalizar = async dados => {
        if (!aceitouTermos) {
            enqueueSnackbar("É necessário aceitar os termos de uso para finalizar.", { variant: "warning" })
            return
        }
        setEnviando(true)
        const emailCliente = mesmoEmail ? dados.emailLoja : dados.emailCliente
        const whatsappCliente = mesmoWhatsapp ? dados.whatsappLoja : dados.whatsappCliente
        const body = {
            aceitouTermos: true,
            rascunhoToken: rascunhoToken || undefined,
            nome: dados.nome,
            cnpj: dados.cnpj,
            categoria: dados.categoria,
            emailLoja: dados.emailLoja,
            whatsappLoja: dados.whatsappLoja,
            endereco: dados.endereco,
            numero: dados.numero,
            bairro: dados.bairro,
            cep: dados.cep,
            nomeCidade: dados.nomeCidade,
            ufCidade: dados.ufCidade,
            latitude: dados.latitude,
            longitude: dados.longitude,
            nomeResponsavel: dados.nomeResponsavel,
            emailCliente,
            whatsappCliente,
            logoBase64: logoBase64 || undefined,
            corPrimaria: dados.corPrimaria,
            corSecundaria: dados.corSecundaria,
            planoAssinatura: dados.planoAssinatura,
        }
        const resp = await onboardingRestaurante(body)
        setEnviando(false)
        if (resp.retornoErro) {
            enqueueSnackbar(resp.mensagem || "Não foi possível concluir o cadastro.", { variant: "error" })
            return
        }
        setResultado(resp.data)
        setActiveStep(PASSO_PAGAMENTO)
    }

    async function entrarAgora() {
        if (!resultado) return
        try {
            const email = resultado.login
            const senha = resultado.senha
            const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF") || "null")
            const fornecedor = {
                appNome: aplicativoDados?.appNome,
                email,
                hashSenha: senha,
                codigoDispositivo: "SistemaReact",
                token: "a~I?;;+_@!AL^",
            }
            const r = await api.post("fornecedor/LoginFornecedor", fornecedor, {
                headers: { "Content-Type": "application/json" },
            })
            if (!r.data || typeof r.data === "string" || r.data.codErro > 0) {
                enqueueSnackbar(
                    "Não foi possível entrar automaticamente. Use as credenciais enviadas ao seu e-mail.",
                    { variant: "warning" }
                )
                return
            }
            const chave = "Basic " + btoa(unescape(encodeURIComponent(email + ":" + senha)))
            localStorage.setItem("chaveSistema", chave)
            localStorage.removeItem("estabelecimentoAtualCF")
            let parametros
            try {
                if (servicos && servicos.buscarParametrosLogin) {
                    parametros = await servicos.buscarParametrosLogin(chave)
                }
            } catch (_) {
                // parâmetros são carregados novamente na navegação; segue o login
            }
            atualizarConfiguracoes({
                user: { id: r.data.id, perfil: r.data.perfil, usuario: r.data.email, parametros },
            })
            history.push("/servicos")
        } catch (error) {
            RegistrarLogErro(error, "OnboardingRestaurante.entrarAgora")
            enqueueSnackbar("Erro ao entrar. Use as credenciais enviadas ao seu e-mail.", { variant: "error" })
        }
    }

    // ----- Wizard (o Pagamento é o último passo, exibido após o cadastro concluir) -----
    return (
        <div className={classes.page}>
            <Paper className={classes.card} elevation={0}>
                <div className={classes.header}>
                    <Typography variant="h5" className={classes.titulo}>
                        Comece a usar a Cliente Fiel
                    </Typography>
                    <Typography className={classes.subtitulo}>
                        {activeStep === PASSO_PAGAMENTO
                            ? resultado && resultado.faturaPaga
                                ? "Pagamento confirmado. Confira seus dados abaixo."
                                : "Use o QR Code abaixo para pagar sua primeira fatura."
                            : somenteLeitura
                            ? "Revisão dos seus dados cadastrados (somente leitura)."
                            : veioDeLink
                            ? "Confira os dados preenchidos, complete o que faltar e finalize seu cadastro."
                            : "Cadastre seu restaurante em poucos passos e comece hoje mesmo."}
                    </Typography>
                </div>

                <Stepper activeStep={activeStep} alternativeLabel nonLinear className={classes.stepper}>
                    {PASSOS.map((label, index) => (
                        <Step key={label} completed={somenteLeitura && index < PASSO_PAGAMENTO}>
                            <StepButton
                                onClick={() => irParaPasso(index)}
                                disabled={index === PASSO_PAGAMENTO && !resultado}
                            >
                                {label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>

                <form className={classes.body} onSubmit={handleSubmit(finalizar)}>
                    {/* Passos de dados (0–4). Em modo revisão o fieldset desabilita toda edição. */}
                    <fieldset
                        disabled={somenteLeitura}
                        style={{
                            border: 0,
                            margin: 0,
                            padding: 0,
                            minInlineSize: "auto",
                            pointerEvents: somenteLeitura ? "none" : "auto",
                        }}
                    >
                    {/* Passo 0 — Loja */}
                    {activeStep === 0 && (
                        <>
                            <TextField
                                className={classes.campo}
                                fullWidth
                                variant="outlined"
                                label="Nome do restaurante"
                                {...register("nome", { required: "Informe o nome da loja." })}
                                error={!!errors.nome}
                                helperText={errors.nome?.message}
                            />
                            <Controller
                                name="cnpj"
                                control={control}
                                rules={{
                                    required: "Informe o CPF ou CNPJ.",
                                    validate: v => {
                                        const d = (v || "").replace(/\D/g, "")
                                        return (
                                            d.length === 11 ||
                                            d.length === 14 ||
                                            "Informe um CPF (11 dígitos) ou CNPJ (14 dígitos) válido."
                                        )
                                    },
                                }}
                                render={({ field }) => (
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="CPF ou CNPJ"
                                        value={field.value}
                                        onChange={field.onChange}
                                        InputProps={{ inputComponent: MascaraCpfCnpj }}
                                        error={!!errors.cnpj}
                                        helperText={errors.cnpj?.message}
                                    />
                                )}
                            />
                            <Controller
                                name="categoria"
                                control={control}
                                rules={{ required: "Selecione a categoria." }}
                                render={({ field }) => (
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        select
                                        variant="outlined"
                                        label="Categoria"
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!errors.categoria}
                                        helperText={errors.categoria?.message}
                                    >
                                        {CATEGORIAS.map(c => (
                                            <MenuItem key={c} value={c}>
                                                {c}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                            <TextField
                                className={classes.campo}
                                fullWidth
                                variant="outlined"
                                label="E-mail da loja"
                                {...register("emailLoja", {
                                    required: "Informe o e-mail da loja.",
                                    pattern: { value: /^\S+@\S+\.\S+$/, message: "E-mail inválido." },
                                })}
                                error={!!errors.emailLoja}
                                helperText={errors.emailLoja?.message}
                            />
                            <Controller
                                name="whatsappLoja"
                                control={control}
                                rules={{
                                    required: "Informe o WhatsApp da loja.",
                                    minLength: { value: 14, message: "WhatsApp incompleto." },
                                }}
                                render={({ field }) => (
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="WhatsApp da loja"
                                        value={field.value}
                                        onChange={field.onChange}
                                        InputProps={{ inputComponent: MascaraTelefone }}
                                        error={!!errors.whatsappLoja}
                                        helperText={errors.whatsappLoja?.message}
                                    />
                                )}
                            />
                        </>
                    )}

                    {/* Passo 1 — Endereço (Google Maps) */}
                    {activeStep === 1 && (
                        <>
                            <Typography className={classes.subtitulo} style={{ marginBottom: 4 }}>
                                Busque seu endereço e selecione na lista do Google.
                            </Typography>
                            {googleDisponivel ? (
                                <GoogleAutocomplete
                                    onLoad={ref => (autocompleteRef.current = ref)}
                                    onPlaceChanged={onPlaceChanged}
                                    options={{ componentRestrictions: { country: "br" } }}
                                >
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="Endereço"
                                        placeholder="Ex.: Av. Paulista, 1000 - São Paulo"
                                        {...register("endereco", { required: "Informe o endereço." })}
                                        error={!!errors.endereco}
                                        helperText={errors.endereco?.message}
                                    />
                                </GoogleAutocomplete>
                            ) : (
                                <TextField
                                    className={classes.campo}
                                    fullWidth
                                    variant="outlined"
                                    label="Endereço (rua e cidade)"
                                    {...register("endereco", { required: "Informe o endereço." })}
                                    error={!!errors.endereco}
                                    helperText={errors.endereco?.message}
                                />
                            )}
                            <TextField
                                className={classes.campo}
                                fullWidth
                                variant="outlined"
                                label="Número"
                                {...register("numero", { required: "Informe o número." })}
                                error={!!errors.numero}
                                helperText={errors.numero?.message}
                            />
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="Bairro"
                                        {...register("bairro")}
                                    />
                                </Grid>
                                <Grid item xs={8} sm={4}>
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="Cidade"
                                        helperText="Preenchida pelo endereço"
                                        InputProps={{ readOnly: true }}
                                        {...register("nomeCidade")}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2}>
                                    <TextField
                                        className={classes.campo}
                                        fullWidth
                                        variant="outlined"
                                        label="UF"
                                        InputProps={{ readOnly: true }}
                                        {...register("ufCidade")}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {/* Passo 2 — Responsável */}
                    {activeStep === 2 && (
                        <>
                            <TextField
                                className={classes.campo}
                                fullWidth
                                variant="outlined"
                                label="Nome do responsável"
                                {...register("nomeResponsavel", { required: "Informe o nome do responsável." })}
                                error={!!errors.nomeResponsavel}
                                helperText={errors.nomeResponsavel?.message}
                            />

                            <FormControlLabel
                                style={{ marginTop: 12 }}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={mesmoEmail}
                                        onChange={e => setMesmoEmail(e.target.checked)}
                                    />
                                }
                                label="Usar o mesmo e-mail da loja para login"
                            />
                            {!mesmoEmail && (
                                <TextField
                                    className={classes.campo}
                                    fullWidth
                                    variant="outlined"
                                    label="E-mail do responsável (login)"
                                    {...register("emailCliente", {
                                        required: "Informe o e-mail do responsável.",
                                        pattern: { value: /^\S+@\S+\.\S+$/, message: "E-mail inválido." },
                                    })}
                                    error={!!errors.emailCliente}
                                    helperText={errors.emailCliente?.message}
                                />
                            )}

                            <FormControlLabel
                                style={{ marginTop: 4 }}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={mesmoWhatsapp}
                                        onChange={e => setMesmoWhatsapp(e.target.checked)}
                                    />
                                }
                                label="Usar o mesmo WhatsApp da loja"
                            />
                            {!mesmoWhatsapp && (
                                <Controller
                                    name="whatsappCliente"
                                    control={control}
                                    rules={{
                                        required: "Informe o WhatsApp do responsável.",
                                        minLength: { value: 14, message: "WhatsApp incompleto." },
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.campo}
                                            fullWidth
                                            variant="outlined"
                                            label="WhatsApp do responsável"
                                            value={field.value}
                                            onChange={field.onChange}
                                            InputProps={{ inputComponent: MascaraTelefone }}
                                            error={!!errors.whatsappCliente}
                                            helperText={errors.whatsappCliente?.message}
                                        />
                                    )}
                                />
                            )}
                        </>
                    )}

                    {/* Passo 3 — Identidade visual */}
                    {activeStep === 3 && (
                        <>
                            <Typography className={classes.subtitulo} style={{ marginBottom: 8 }}>
                                Personalize a marca da sua loja (opcional).
                            </Typography>
                            <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 8 }}>
                                <div
                                    style={{
                                        width: 88,
                                        height: 88,
                                        borderRadius: 16,
                                        border: "1px dashed #cbd5e1",
                                        backgroundColor: "#f8fafc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden",
                                    }}
                                >
                                    {logoPreview ? (
                                        <img
                                            src={logoPreview}
                                            alt="Logo"
                                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                        />
                                    ) : (
                                        <span style={{ color: "#94a3b8", fontSize: 12 }}>Sem logo</span>
                                    )}
                                </div>
                                <Button variant="outlined" component="label" style={{ borderRadius: 25 }}>
                                    Enviar logomarca
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={e => handleLogo(e.target.files?.[0])}
                                    />
                                </Button>
                            </div>

                            <Grid container spacing={3} style={{ marginTop: 12 }}>
                                <Grid item xs={6}>
                                    <Typography style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>
                                        Cor principal
                                    </Typography>
                                    <Controller
                                        name="corPrimaria"
                                        control={control}
                                        render={({ field }) => (
                                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
                                                <input
                                                    type="color"
                                                    value={field.value || COR_PADRAO}
                                                    onChange={field.onChange}
                                                    style={{ width: 44, height: 40, border: "none", background: "none" }}
                                                />
                                                <span style={{ color: "#6b7280" }}>{field.value}</span>
                                            </div>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>
                                        Cor secundária
                                    </Typography>
                                    <Controller
                                        name="corSecundaria"
                                        control={control}
                                        render={({ field }) => (
                                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
                                                <input
                                                    type="color"
                                                    value={field.value || COR_SECUNDARIA_PADRAO}
                                                    onChange={field.onChange}
                                                    style={{ width: 44, height: 40, border: "none", background: "none" }}
                                                />
                                                <span style={{ color: "#6b7280" }}>{field.value}</span>
                                            </div>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Typography className={classes.subtitulo} style={{ fontSize: 12, marginTop: 8 }}>
                                A barra de finalizar o pedido usará a cor principal.
                            </Typography>
                        </>
                    )}

                    {/* Passo 4 — Plano */}
                    {activeStep === 4 && (
                        <>
                        <Controller
                            name="planoAssinatura"
                            control={control}
                            rules={{ required: "Selecione um plano." }}
                            render={({ field }) => (
                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                    {PLANOS_ONBOARDING.map(plano => {
                                        const selecionado = field.value === plano.value
                                        return (
                                            <Grid item xs={12} sm={4} key={plano.value}>
                                                <Card
                                                    elevation={0}
                                                    className={`${classes.planoCard} ${
                                                        selecionado ? classes.planoCardSelecionado : ""
                                                    }`}
                                                    onClick={() => field.onChange(plano.value)}
                                                >
                                                    {plano.recomendado && (
                                                        <Chip
                                                            size="small"
                                                            label="Recomendado"
                                                            className={classes.chipRecomendado}
                                                        />
                                                    )}
                                                    <CardContent className={classes.planoCardContent}>
                                                        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                                                            {plano.nome}
                                                        </Typography>
                                                        <Typography className={classes.planoPreco} variant="h5">
                                                            R$ {plano.preco}
                                                            <span style={{ fontSize: 13, fontWeight: 400 }}>/mês</span>
                                                        </Typography>
                                                        <Typography
                                                            className={classes.subtitulo}
                                                            style={{ fontSize: 12, minHeight: 34 }}
                                                        >
                                                            {plano.resumo}
                                                        </Typography>
                                                        <div className={classes.planoFeatures}>
                                                            {plano.features.map(f => (
                                                                <div key={f} className={classes.feature}>
                                                                    <CheckCircleIcon className={classes.featureIcon} />
                                                                    {f}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            )}
                        />
                        {!somenteLeitura && (
                            <FormControlLabel
                                style={{ marginTop: 20, display: "flex", alignItems: "center" }}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={aceitouTermos}
                                        onChange={e => setAceitouTermos(e.target.checked)}
                                    />
                                }
                                label={
                                    <span>
                                        Li e aceito os{" "}
                                        <Link href={URL_TERMOS} target="_blank" rel="noopener noreferrer">
                                            termos de uso da Cliente Fiel
                                        </Link>
                                        .
                                    </span>
                                }
                            />
                        )}
                        </>
                    )}
                    </fieldset>

                    {/* Passo 5 — Pagamento (QR Code da 1ª fatura). Só é exibido após o cadastro concluir. */}
                    {activeStep === PASSO_PAGAMENTO && resultado && (
                        <div style={{ textAlign: "center", paddingTop: 8 }}>
                            <CheckCircleIcon className={classes.sucessoIcon} />
                            <Typography variant="h5" className={classes.titulo} style={{ marginTop: 8 }}>
                                {resultado.usuarioExistente ? "Loja cadastrada! 🎉" : "Cadastro concluído! 🎉"}
                            </Typography>
                            <Typography className={classes.subtitulo}>
                                {resultado.usuarioExistente ? (
                                    <>
                                        A nova loja foi associada à sua conta. Acesse com o seu usuário{" "}
                                        <strong>{resultado.login}</strong> (mesma senha de sempre) e selecione a
                                        nova loja.
                                    </>
                                ) : (
                                    <>
                                        Enviamos seu usuário e senha para <strong>{resultado.login}</strong>.
                                    </>
                                )}
                            </Typography>

                            <div className={classes.faturaBox} style={{ textAlign: "center" }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                                    {resultado.faturaPaga
                                        ? `Fatura paga (${resultado.planoLabel})`
                                        : `Pague sua primeira fatura (${resultado.planoLabel})`}
                                </Typography>
                                <Typography style={{ marginTop: 6 }}>
                                    Valor:{" "}
                                    <strong>
                                        R${" "}
                                        {resultado.faturaValor != null
                                            ? Number(resultado.faturaValor).toFixed(2).replace(".", ",")
                                            : "--"}
                                    </strong>
                                </Typography>
                                {resultado.faturaVencimento && (
                                    <Typography>Vencimento: {resultado.faturaVencimento}</Typography>
                                )}

                                {resultado.faturaPaga ? (
                                    <div style={{ marginTop: 16 }}>
                                        <Chip
                                            label="Pagamento confirmado ✓"
                                            style={{
                                                backgroundColor: "var(--cor-botao-salvar)",
                                                color: "#fff",
                                                fontWeight: 700,
                                            }}
                                        />
                                        <Typography
                                            className={classes.subtitulo}
                                            style={{ fontSize: 12, marginTop: 10 }}
                                        >
                                            Sua assinatura está ativa. Obrigado!
                                        </Typography>
                                    </div>
                                ) : (
                                    <>
                                        {(resultado.pixCopiaECola || resultado.urlIugu) &&
                                            (qrPagamento ? (
                                                <div style={{ marginTop: 16 }}>
                                                    <img
                                                        src={qrPagamento}
                                                        alt="QR Code de pagamento"
                                                        style={{ width: 220, height: 220 }}
                                                    />
                                                    <Typography
                                                        className={classes.subtitulo}
                                                        style={{ fontSize: 12, marginTop: 8 }}
                                                    >
                                                        {resultado.pixCopiaECola
                                                            ? "Escaneie o QR Code com o app do seu banco para pagar via PIX."
                                                            : "Escaneie o QR Code com o celular para pagar por PIX, boleto ou cartão."}
                                                    </Typography>
                                                </div>
                                            ) : (
                                                <Typography
                                                    className={classes.subtitulo}
                                                    style={{ fontSize: 12, marginTop: 16 }}
                                                >
                                                    Gerando QR Code...
                                                </Typography>
                                            ))}

                                        {resultado.pixCopiaECola && (
                                            <div style={{ marginTop: 16 }}>
                                                <Typography
                                                    style={{
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        color: "#374151",
                                                        marginBottom: 4,
                                                    }}
                                                >
                                                    PIX copia e cola
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    variant="outlined"
                                                    value={resultado.pixCopiaECola}
                                                    InputProps={{
                                                        readOnly: true,
                                                        style: { fontSize: 12, wordBreak: "break-all" },
                                                    }}
                                                    onFocus={e => e.target.select()}
                                                />
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    style={{ borderRadius: 25, marginTop: 8 }}
                                                    onClick={copiarPix}
                                                >
                                                    Copiar código PIX
                                                </Button>
                                            </div>
                                        )}

                                        {resultado.urlIugu && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    justifyContent: "center",
                                                    flexWrap: "wrap",
                                                    marginTop: 12,
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    style={{ borderRadius: 25 }}
                                                    href={resultado.urlIugu}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Pagar agora
                                                </Button>
                                                <Button
                                                    variant="text"
                                                    style={{ borderRadius: 25 }}
                                                    onClick={copiarLinkPagamento}
                                                >
                                                    Copiar link
                                                </Button>
                                            </div>
                                        )}

                                        <div style={{ marginTop: 8 }}>
                                            <Button
                                                variant="text"
                                                style={{ borderRadius: 25 }}
                                                onClick={() => atualizarStatusPagamento({ silencioso: false })}
                                            >
                                                Já paguei? Atualizar status
                                            </Button>
                                        </div>

                                        <Typography
                                            className={classes.subtitulo}
                                            style={{ marginTop: 12, fontSize: 12 }}
                                        >
                                            Você já pode usar o sistema agora, mesmo antes de pagar. Ao pagar a
                                            fatura, sua assinatura é ativada automaticamente.
                                        </Typography>
                                    </>
                                )}
                            </div>

                            {resultado.usuarioExistente || !resultado.senha ? (
                                <Button
                                    className={classes.btnPrimario}
                                    style={{ marginTop: 24 }}
                                    onClick={() => history.push("/login")}
                                >
                                    Ir para o login
                                </Button>
                            ) : (
                                <Button
                                    className={classes.btnPrimario}
                                    style={{ marginTop: 24 }}
                                    onClick={entrarAgora}
                                >
                                    Entrar e começar a usar agora
                                </Button>
                            )}

                            {somenteLeitura && (
                                <div style={{ marginTop: 12 }}>
                                    <Button
                                        variant="text"
                                        style={{ borderRadius: 25 }}
                                        onClick={() => setActiveStep(0)}
                                    >
                                        Revisar meus dados (somente leitura)
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}

                    {activeStep < PASSO_PAGAMENTO && (
                        <div className={classes.acoes}>
                            <Button disabled={activeStep === 0 || enviando} onClick={voltar}>
                                Voltar
                            </Button>
                            <div style={{ display: "flex", gap: 8 }}>
                                {somenteLeitura ? (
                                    activeStep < PASSO_PLANO ? (
                                        <Button className={classes.btnPrimario} onClick={avancar}>
                                            Avançar
                                        </Button>
                                    ) : (
                                        <Button
                                            className={classes.btnPrimario}
                                            onClick={() => setActiveStep(PASSO_PAGAMENTO)}
                                        >
                                            Ir para pagamento
                                        </Button>
                                    )
                                ) : (
                                    <>
                                        {estaLogado && (
                                            <Button
                                                onClick={salvarRascunho}
                                                disabled={salvandoRascunho || enviando}
                                                style={{ borderRadius: 25 }}
                                            >
                                                {salvandoRascunho ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    "Salvar e enviar ao cliente"
                                                )}
                                            </Button>
                                        )}
                                        {activeStep < PASSO_PLANO ? (
                                            <Button className={classes.btnPrimario} onClick={avancar}>
                                                Avançar
                                            </Button>
                                        ) : (
                                            <Button
                                                className={classes.btnPrimario}
                                                type="submit"
                                                disabled={enviando || !aceitouTermos}
                                            >
                                                {enviando ? (
                                                    <CircularProgress size={22} style={{ color: "#fff" }} />
                                                ) : (
                                                    "Finalizar cadastro"
                                                )}
                                            </Button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </form>
            </Paper>

            <Dialog open={!!linkDialog} onClose={() => setLinkDialog(null)} maxWidth="sm" fullWidth>
                <DialogTitle>Rascunho salvo</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Envie este link para o dono do restaurante conferir os dados e finalizar o
                        cadastro:
                    </DialogContentText>
                    <TextField
                        fullWidth
                        variant="outlined"
                        value={linkDialog || ""}
                        InputProps={{ readOnly: true }}
                        onFocus={e => e.target.select()}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLinkDialog(null)}>Fechar</Button>
                    <Button className={classes.btnPrimario} onClick={copiarLink}>
                        Copiar link
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
